import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\FileController::signedUrl
* @see Http/Controllers/FileController.php:62
* @route '/projects/{project}/articles/{article}/files/{file}/signed-url'
*/
export const signedUrl = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: signedUrl.url(args, options),
    method: 'get',
})

signedUrl.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/articles/{article}/files/{file}/signed-url',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FileController::signedUrl
* @see Http/Controllers/FileController.php:62
* @route '/projects/{project}/articles/{article}/files/{file}/signed-url'
*/
signedUrl.url = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            article: args[1],
            file: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        article: typeof args.article === 'object'
        ? args.article.id
        : args.article,
        file: typeof args.file === 'object'
        ? args.file.id
        : args.file,
    }

    return signedUrl.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{article}', parsedArgs.article.toString())
            .replace('{file}', parsedArgs.file.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FileController::signedUrl
* @see Http/Controllers/FileController.php:62
* @route '/projects/{project}/articles/{article}/files/{file}/signed-url'
*/
signedUrl.get = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: signedUrl.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FileController::signedUrl
* @see Http/Controllers/FileController.php:62
* @route '/projects/{project}/articles/{article}/files/{file}/signed-url'
*/
signedUrl.head = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: signedUrl.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\FileController::signedUrl
* @see Http/Controllers/FileController.php:62
* @route '/projects/{project}/articles/{article}/files/{file}/signed-url'
*/
const signedUrlForm = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: signedUrl.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FileController::signedUrl
* @see Http/Controllers/FileController.php:62
* @route '/projects/{project}/articles/{article}/files/{file}/signed-url'
*/
signedUrlForm.get = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: signedUrl.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FileController::signedUrl
* @see Http/Controllers/FileController.php:62
* @route '/projects/{project}/articles/{article}/files/{file}/signed-url'
*/
signedUrlForm.head = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: signedUrl.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

signedUrl.form = signedUrlForm

/**
* @see \App\Http\Controllers\FileController::link
* @see Http/Controllers/FileController.php:76
* @route '/projects/{project}/articles/{article}/files/{file}/link'
*/
export const link = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: link.url(args, options),
    method: 'post',
})

link.definition = {
    methods: ["post"],
    url: '/projects/{project}/articles/{article}/files/{file}/link',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\FileController::link
* @see Http/Controllers/FileController.php:76
* @route '/projects/{project}/articles/{article}/files/{file}/link'
*/
link.url = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            article: args[1],
            file: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        article: typeof args.article === 'object'
        ? args.article.id
        : args.article,
        file: typeof args.file === 'object'
        ? args.file.id
        : args.file,
    }

    return link.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{article}', parsedArgs.article.toString())
            .replace('{file}', parsedArgs.file.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FileController::link
* @see Http/Controllers/FileController.php:76
* @route '/projects/{project}/articles/{article}/files/{file}/link'
*/
link.post = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: link.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\FileController::link
* @see Http/Controllers/FileController.php:76
* @route '/projects/{project}/articles/{article}/files/{file}/link'
*/
const linkForm = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: link.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\FileController::link
* @see Http/Controllers/FileController.php:76
* @route '/projects/{project}/articles/{article}/files/{file}/link'
*/
linkForm.post = (args: { project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } } | [project: string | number | { id: string | number }, article: string | number | { id: string | number }, file: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: link.url(args, options),
    method: 'post',
})

link.form = linkForm

const files = {
    signedUrl: Object.assign(signedUrl, signedUrl),
    link: Object.assign(link, link),
}

export default files